var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRefreshIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.4167 5.83317C7.46028 5.83317 5.00004 8.29341 5.00004 11.2498C5.00004 14.2063 7.46028 16.6665 10.4167 16.6665C13.3731 16.6665 15.8334 14.2063 15.8334 11.2498C15.8334 10.7896 16.2065 10.4165 16.6667 10.4165C17.1269 10.4165 17.5 10.7896 17.5 11.2498C17.5 15.1267 14.2936 18.3332 10.4167 18.3332C6.5398 18.3332 3.33337 15.1267 3.33337 11.2498C3.33337 7.37293 6.5398 4.1665 10.4167 4.1665H13.75C14.2103 4.1665 14.5834 4.5396 14.5834 4.99984C14.5834 5.46007 14.2103 5.83317 13.75 5.83317H10.4167Z",
    fill: "#21272F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.6608 1.91058C10.9862 1.58514 11.5139 1.58514 11.8393 1.91058L14.3393 4.41058C14.6647 4.73602 14.6647 5.26366 14.3393 5.58909L11.8393 8.08909C11.5139 8.41453 10.9862 8.41453 10.6608 8.08909C10.3353 7.76366 10.3353 7.23602 10.6608 6.91058L12.5715 4.99984L10.6608 3.08909C10.3353 2.76366 10.3353 2.23602 10.6608 1.91058Z",
    fill: "#21272F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshIcon);
export default __webpack_public_path__ + "static/media/refreshIcon.ead66c7f10802a8086585c84eb4236cb.svg";
export { ForwardRef as ReactComponent };